import { defineMessages } from 'react-intl';

export default defineMessages({
    categoryDocumentTitle: {
        defaultMessage: '{portalName} - {categoryName}',
        description: 'Document title for portal article topics page',
        id: 'cv.categories.page.title',
    },
});
